import { PatchInvoiceDocument } from '@/pages/Seller/SellerDocuments/EditInvoiceModal';
import {
  InvoiceDocument,
  InvoiceDocumentsResponse,
  InvoiceDocumentSuggestionsType,
} from '../types';
import { client } from './axiosClient';

export const getInvoiceDocumentSuggestedValues = async (
  company_id: string,
  id: number,
  code: number
) => {
  const res = await client.get<InvoiceDocument>(
    `/client/invoice-documents/${id}/suggestions/${code}/values`,
    {
      params: {
        company_id,
      },
    }
  );
  return res.data;
};

export const getInvoiceDocumentsErrors = async (
  company_id: string | undefined,
  year: number,
  month: number
) => {
  const res = await client.get<number>('/client/invoice-documents/errors', {
    params: {
      company_id,
      year,
      month,
    },
  });
  return res.data;
};

export const getInvoiceDocumentsWarnings = async (
  company_id: string | undefined,
  year: number,
  month: number
) => {
  const res = await client.get<number>('/client/invoice-documents/warnings', {
    params: {
      company_id,
      year,
      month,
    },
  });
  return res.data;
};

export const postErrorFeedback = async (
  id: number,
  company_id: string,
  external_user_uuid: string,
  error_name?: string,
  option?: string,
  comment?: string
) => {
  const res = await client.post(
    `/client/invoice-documents/${id}/feedback`,
    {
      error_name,
      comment,
      option,
      external_user_uuid,
    },
    {
      params: {
        company_id,
      },
    }
  );
  return res.data;
};

export const getInvoiceDocuments = async (
  company_id: string | undefined,
  year: number,
  month: number,
  filter: string | undefined,
  error_code: string[],
  warning_code: string[],
  page: number,
  controller: AbortController
) => {
  const res = await client.get<InvoiceDocumentsResponse>(
    '/client/invoice-documents',
    {
      params: {
        company_id,
        year,
        page,
        month,
        filter,
        error_code,
        warning_code,
      },
      signal: controller.signal,
      paramsSerializer: {
        indexes: null,
      },
    }
  );
  return res.data;
};

export const getListOfErrorsLink = async (id: number, company_id: string) => {
  const res = await client.post<string>(
    `/client/uploaded-documents-file-errors-message/${id}/download`,
    undefined,
    {
      params: {
        company_id,
      },
    }
  );

  return res.data;
};

export const patchInvoiceDocuments = async (
  id: number,
  input: PatchInvoiceDocument,
  company_id?: string
) => {
  const res = await client.patch(`/client/invoice-documents/${id}`, input, {
    params: { company_id },
  });
  return res.data;
};

export const postMuteInvoiceDocument = async (
  id: number,
  company_id?: string
) => {
  const res = await client.post(
    `/client/invoice-documents/${id}/mute`,
    undefined,
    {
      params: { company_id },
    }
  );
  return res.data;
};

export const getInvoiceDocumentSuggestions = async (
  company_id: string,
  id: number
) => {
  const res = await client.get<InvoiceDocumentSuggestionsType[]>(
    `/client/invoice-documents/${id}/suggestions`,
    {
      params: {
        company_id,
      },
    }
  );
  return res.data;
};

export const postInvoiceDocumentSuggestionsCode = async (
  company_id: string,
  id: number,
  code: number
) => {
  const res = await client.post<string>(
    `/client/invoice-documents/${id}/suggestions/${code}/apply`,
    undefined,
    {
      params: {
        company_id,
      },
    }
  );
  return res.data;
};
